import type { RefObject } from 'react'
import {
  getLineBounds,
  applyChange,
  insertAtSelection,
  quoteRe,
} from '../utils'

export const newQuoteLineAction = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
): boolean => {
  const el = textareaRef.current
  if (!el) return false

  const s = el.selectionStart ?? 0
  const e = el.selectionEnd ?? s

  const before = value.slice(0, s)
  const after = value.slice(e)

  const { line: lineBefore } = getLineBounds(before, before.length)
  const m = lineBefore.match(quoteRe)
  if (!m) return false

  const indentBefore = m[1] || ''
  const indentAfter = m[2] || ''
  const insert = `\n${indentBefore}>${indentAfter}`

  const { next, caret } = insertAtSelection(before, insert, after)
  applyChange(textareaRef, onChange, next, caret)
  return true
}
